var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box wrapper-payroll-detail" }, [
    _c(
      "h2",
      { staticClass: "title is-4 has-text-primary title-payroll-details" },
      [_vm._v("\n    Detalle de la Nómina\n  ")]
    ),
    _c("div", { staticClass: "columns is-multiline" }, [
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile" },
        [
          _c("BField", { attrs: { label: "Tipo de nómina" } }, [
            _c(
              "div",
              { staticClass: "field has-addons" },
              [
                _vm._l(_vm.payrollTypeCatalog, function(payrollType) {
                  return [
                    _c(
                      "BRadioButton",
                      {
                        key: payrollType.key,
                        attrs: {
                          name: "type",
                          "native-value": payrollType.value
                        },
                        on: {
                          input: function($event) {
                            return _vm.onInput("type", $event)
                          }
                        },
                        model: {
                          value: _vm.privateType,
                          callback: function($$v) {
                            _vm.privateType = $$v
                          },
                          expression: "privateType"
                        }
                      },
                      [_c("span", [_vm._v(_vm._s(payrollType.label))])]
                    )
                  ]
                })
              ],
              2
            )
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile" },
        [
          _c(
            "BField",
            { attrs: { label: "Fecha del pago", "label-for": "paymentDate" } },
            [
              _c(
                "BDatepicker",
                _vm._b(
                  {
                    attrs: {
                      id: "paymentDate",
                      value: _vm.privatePaymentDate,
                      "date-parser": _vm.dateParser,
                      icon: "calendar-today"
                    },
                    on: {
                      input: function($event) {
                        return _vm.onInput("paymentDate", $event)
                      }
                    }
                  },
                  "BDatepicker",
                  _vm.calendarProps,
                  false
                )
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile" },
        [
          _c(
            "BField",
            {
              attrs: {
                "label-for": "paymentPeriodStart",
                label: "Fecha inicial del pago"
              }
            },
            [
              _c(
                "BDatepicker",
                _vm._b(
                  {
                    attrs: {
                      id: "paymentPeriodStart",
                      value: _vm.privatePaymentPeriodStart,
                      "date-parser": _vm.dateParser,
                      icon: "calendar-import"
                    },
                    on: {
                      input: function($event) {
                        return _vm.onInput("paymentPeriodStart", $event)
                      }
                    }
                  },
                  "BDatepicker",
                  _vm.calendarProps,
                  false
                )
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile" },
        [
          _c(
            "BField",
            {
              attrs: {
                "label-for": "paymentPeriodEnd",
                label: "Fecha final del pago"
              }
            },
            [
              _c(
                "BDatepicker",
                _vm._b(
                  {
                    attrs: {
                      id: "paymentPeriodEnd",
                      value: _vm.privatePaymentPeriodEnd,
                      "date-parser": _vm.dateParser,
                      icon: "calendar-export"
                    },
                    on: {
                      input: function($event) {
                        return _vm.onInput("paymentPeriodEnd", $event)
                      }
                    }
                  },
                  "BDatepicker",
                  _vm.calendarProps,
                  false
                )
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile" },
        [
          _c(
            "BField",
            { attrs: { "label-for": "earnedDays", label: "Días pagados" } },
            [
              _c("BInput", {
                attrs: {
                  id: "earnedDays",
                  type: "number",
                  step: "0.001",
                  min: "0",
                  placeholder: "14",
                  icon: "calendar-star",
                  required: ""
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("earnedDays", $event)
                  }
                },
                model: {
                  value: _vm.privateEarnedDays,
                  callback: function($$v) {
                    _vm.privateEarnedDays = $$v
                  },
                  expression: "privateEarnedDays"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }